// extracted by mini-css-extract-plugin
export default {"thumb":"F8UjY_BtjxNI279SSUku"};